// Modules/Index.js
import React, { useEffect, useState } from 'react';
import Navbar from '../../Components/Common/Navbar';
import Footer from '../../Components/Common/Footer';
import HeroSection from '../../Components/Sections/HeroSections';
import FeaturesSection from '../../Components/Sections/FeaturesSection';
import TestimonialsSection from '../../Components/Sections/TestimonialsSection';
import DemoSection from '../../Components/Sections/DemoSection';
import ProductFeaturesSection from '../../Components/Sections/ProductFeaturesSection';
import PackagesSection from '../../Components/Sections/PackagesSection';
import SupportSection from '../../Components/Sections/SupportSection';
import TeamSection from '../../Components/Sections/TeamSection';
import VisitSection from '../../Components/Sections/VisitSection';
import FAQSection from '../../Components/Sections/FAQSection';
import ContactSection from '../../Components/Sections/ContactSection';
import indexAPI from './IndexAPI';
import { useSearchParams } from 'react-router-dom';
import { getImagePath } from '../../Utils/Utilities';
import { useBrand } from '../../Utils/BrandContext';

const IndexPage = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { brand: activeBrand } = useBrand();

  const rfdAvl = false;
  const flashOfferOn = true
  const isMidnight = [0, 1, 23].includes(new Date().getHours());

  const brandLogo = activeBrand === 'bz' ? getImagePath("/Images/Biziverse.png") : getImagePath("/Images/QikERP.png");
  // Handle scroll on mount - either to hash section or top
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      // Wait for components to render
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const navbarHeight = 70;
          const targetPosition = element.offsetTop - navbarHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Force scroll to top if no hash
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, []);

  const handleLoginClick = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      const navbarHeight = 70;
      const targetPosition = heroSection.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      setTimeout(() => {
        const mobileInput = document.getElementById('mobile');
        if (mobileInput) {
          mobileInput.focus();
          const wrapper = mobileInput.parentElement;
          if (wrapper) {
            wrapper.style.borderColor = '#e88421';
            wrapper.style.boxShadow = '0 0 10px rgba(232, 132, 33, 0.5)';

            setTimeout(() => {
              wrapper.style.borderColor = '';
              wrapper.style.boxShadow = '';
            }, 2000);
          }
        }
      }, 600);
    }
  };

  const handleLogin = async (mobileNumber) => {
    setLoading(true);

    try {
      const result = await indexAPI.handleLogin(mobileNumber, activeBrand);

      // Redirect based on response
      window.location.href = result.redirectUrl;

    } catch (err) {
      alert(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleScrollToPricing = () => {
    const packagesSection = document.getElementById('simplePricing');
    if (packagesSection) {
      window.scrollTo({ top: packagesSection.offsetTop - 70, behavior: 'smooth' });
    }
  };

  const handleBuyNow = (editionId) => {
    // If called from PackagesSection with an editionId, scroll to hero instead
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      const navbarHeight = 70;
      const targetPosition = heroSection.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      setTimeout(() => {
        const mobileInput = document.getElementById('mobile');
        if (mobileInput) {
          mobileInput.focus();
        }
      }, 600);
    }
  };
  return (
    <div className="min-h-screen bg-white">
      <Navbar logo={brandLogo} onLoginClick={handleLoginClick} />

      <main>
        <HeroSection
          onGetStarted={handleLogin}
          onLogin={handleLogin}
          loading={loading}
          rfdAvl={rfdAvl}
          flashOfferOn={flashOfferOn}
          isMidnight={isMidnight}
          logo={brandLogo}
        />
        <FeaturesSection onBuyNow={handleBuyNow} pricing={{ silver: 2999, gold: 4999 }}
          rfdAvl={rfdAvl} isFromIdx={true}
        />
        {/* <TestimonialsSection /> */}
        <DemoSection />
        <ProductFeaturesSection onBuyNow={handleScrollToPricing} />

        {/* Packages/Pricing Section */}
        <PackagesSection
          onBuyNow={handleBuyNow}
          pageName='GQIK'
        />
        <TestimonialsSection brandLogo={brandLogo} />

        {/* Support Section */}
        <SupportSection />
        <TeamSection />
        <VisitSection />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default IndexPage;